Vue.component("app-simple-event-registration-screen", {
    props: {
        staff: {
            required: true,
            default: []
        },
        companys: {
            required: true,
            default: null
        },
        event: {
            required: true
        },
        dietary: {
            required: true
        },
        promoCodes: {
            required: false,
            default: []
        },
        user: {
            required: true
        },
        donations: {
            required: false,
            default: false
        },
        donationenable: {
            required: true
        },
        pricegroup: {
            required: false,
            default: []
        },
        usedcoupon: {
            required: false
        },
        scriptendpoint: "",
        preselectedvenueid: {
            required: false,
            default: 0
        }
    },

    /*
     * Bootstrap the component. Load the initial data.
     */
    ready: function() {
        if (this.forms.eventSignup.pricingOption) {
            this.lastPrice = this.getPriceAfterApplyCoupon(
                this.forms.eventSignup.pricingOption.price
            );
        }
        window.addEventListener("message", event => {
            if (typeof event.data == "string") {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.eventSignup.busy = false;
                        swal.close();
                    }, 2000);
                } catch (e) {
                    this.forms.eventSignup.busy = false;
                    // swal.close()
                }
            }
        });
        this.setVenues();
        if (this.preselectedvenueid) {
            var self = this;
            var allVenues = this.venues.concat(this.online_venues);
            var preselected = _.find(allVenues, function(v) { return v.id == self.preselectedvenueid; });
            if (preselected) self.selectVenue(preselected);
        }
        this.setExtras();
        this.setDietary();
        this.setMembers();
    },

    /*
     * Initial state of the component's data.
     */
    data: function() {
        return {
            totalGroupBookingUser: 0,
            lastPrice: 0,
            prices: [],
            redirect_form_key: [],
            used_coupon_discount: 0,
            promo_code_id: 0,
            venues: [],
            online_venues: [],
            pricingOptions: [],
            dates: [],
            extras: [],
            selectedStaff: [],
            members: [],
            pendingMembers: [],
            pendingMembersEmails: [],
            selectedStaffCount: 0,
            inviteStaff: false,
            isComanySetup: false,
            AttendTypeState: false,
            TicketTypeState: false,
            instantlink: "",
            payment_token: "",
            instant_eft_success: false,
            invite_email: "",
            addingMemberDetails: false,
            id_number: "",
            id_type: "",
            country_of_issue: "",
            date_of_birth: "",
            post_code: "",
            postal_address: "",
            incometax_reference_number: "",
            company_name: "",
            company_registrations_number: "",
            errors: {
                company: [],
                invite: []
            },
            company: {
                invite: {
                    first_name: "",
                    last_name: "",
                    cell: "",
                    alternative_cell: "",
                    email: "",
                    id_number: ""
                }
            },
            forms: {
                eventSignup: $.extend(
                    true,
                    new AppForm({
                        busy: false,
                        venue: null,
                        pricingOption: null,
                        dates: [],
                        extras: [],
                        staffs: [],
                        dietaryRequirement: null,
                        paymentOption: null,
                        card: null,
                        terms: false,
                        donations: 0
                    }),
                    App.forms.eventSignup
                )
            },
            addingNewCard: false,
            newcard: {
                number: "",
                holder: "",
                exp_month: "",
                exp_year: "",
                cvv: "",
                return: "",
                errors: []
            },
            threeDs: {
                url: "",
                connector: "",
                MD: "",
                TermUrl: "",
                PaReq: ""
            },
            readyForThreeDs: false,
            address: {
                errors: []
            },
            checkoutId: null,
            entityId: null
        };
    },

    watch: {
        "forms.eventSignup.pricingOption": function(val, oldVal) {
            var vm = this;
            if (oldVal) {
                this.lastPrice = oldVal.price;
            }
            if (val) {
                Vue.set(vm.forms.eventSignup, "dates", []);
                var numberOfDates = vm.forms.eventSignup.venue.dates.length;
                var pricingDayCount =
                    vm.forms.eventSignup.pricingOption.day_count;
                if (this.prices.length == 0) {
                    this.prices.push(
                        this.forms.eventSignup.pricingOption.discounted_price
                    );
                    if (
                        this.getPriceAfterApplyCoupon(
                            this.forms.eventSignup.pricingOption.price
                        ) ==
                        this.forms.eventSignup.pricingOption.discounted_price
                    ) {
                        this.totalGroupBookingUser = 1;
                    }
                } else {
                    this.updatedPrices();
                }
                if (numberOfDates <= pricingDayCount) {
                    _.forEach(vm.forms.eventSignup.venue.dates, function(
                        date,
                        dateKey
                    ) {
                        vm.forms.eventSignup.dates.push(date);
                    });
                }
            }
        },
        TicketTypeState: function(val, oldVal) {
            if (val) {
                var found = 0;
                for (var i = 0; i < this.members.length; i++) {
                    if (this.members[i].email == this.user.email) {
                        found++;
                        if (
                            this.getPriceAfterApplyCoupon(
                                this.forms.eventSignup.pricingOption.price
                            ) ==
                            this.forms.eventSignup.pricingOption
                                .discounted_price
                        ) {
                            this.totalGroupBookingUser = 1;
                        }
                    }
                }
                if (found == 0 && this.members.length == 0) {
                    this.members.push({
                        first_name: this.user.first_name,
                        last_name: this.user.last_name,
                        email: this.user.email,
                        id_number: this.user.id_number,
                        alternative_cell: this.user.alternative_cell,
                        cell: this.user.cell
                    });
                    this.prices = [];
                    if (this.forms.eventSignup.pricingOption) {
                        this.prices.push(
                            this.forms.eventSignup.pricingOption
                                .discounted_price
                        );
                        if (
                            this.getPriceAfterApplyCoupon(
                                this.forms.eventSignup.pricingOption.price
                            ) ==
                            this.forms.eventSignup.pricingOption
                                .discounted_price
                        ) {
                            this.totalGroupBookingUser = 1;
                        }
                    }
                    this.forms.eventSignup.staffs.push(this.user.id);
                }
            }
        }
    },

    mounted() {
        this.loadPeachScript();
    },

    computed: {
        /**
         * Check if the Event only has 1 Venue
         * @returns boolean
         */
        hasSingleVenue: function() {
            return this.event.venues.length === 1;
        },

        /*
         * Compute the total of options the user has selected
         */
        total: function() {
            try {
                const price = this.forms.eventSignup.pricingOption
                    .discounted_price;

                if (this.TicketTypeState == "true") {
                    var getTotal = this.prices.reduce((item, total) => {
                        return parseFloat(item) + parseFloat(total);
                    }, 0);
                    var totalDiscount = this.getTotalGroupBookingDiscount();
                } else {
                    var getTotal = price;
                    var totalDiscount = 0;
                }

                var dietary = this.getTotalDiatry();
                var extras = this.getTotalExtras();
                var donation = this.getDonations();

                var total =
                    parseFloat(getTotal) +
                    parseFloat(dietary) +
                    parseFloat(extras) +
                    parseFloat(donation) -
                    parseFloat(totalDiscount);

                if (this.forms.eventSignup.pricingOption && total == 0)
                    this.forms.eventSignup.paymentOption = null;

                if (total < 0) {
                    total = 0;
                }
                return total.toFixed(2);
            } catch (error) {
                console.log(error.message);
            }
        },

        /*
         * Determine if the venue type selector is set to "physical".
         */
        shouldShowPhysicalVenues: function() {
            return !this.AttendTypeState || this.online_venues.length == 0;
        },

        /*
         * Determine if the plan type selector is set to "online".
         */
        shouldShowOnlineVenues: function() {
            return this.AttendTypeState || this.venues.length == 0;
        }
    },

    methods: {
        loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                console.log(this.scriptendpoint);

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },
        popEft() {
            if (!this.validate()) {
                return;
            }
            this.process();
            this.forms.eventSignup.busy = true;
            this.getEftLink();
        },

        getAppliedDiscountPrice() {
            if (
                this.usedcoupon != null &&
                this.usedcoupon != "" &&
                this.usedcoupon != undefined
            ) {
                this.promo_code_id = this.usedcoupon.id;
            }
            return this.used_coupon_discount;
        },

        /**
         * Add New Card
         */
        addCard() {
            this.newcard.return = `/events/${this.event.slug}/register?threeDs=yes&venue=${this.forms.eventSignup.venue.id}`;

            this.processPayment();

            this.$http
                .post("/account/billing", this.newcard)
                .then(response => {
                    if (
                        response.data.redirect === undefined ||
                        response.data.redirect === null
                    ) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (
                            var i =
                                response.data.redirect.parameters.length - 1;
                            i >= 0;
                            i--
                        ) {
                            this.redirect_form_key.push({
                                form_key:
                                    response.data.redirect.parameters[i].name,
                                form_value:
                                    response.data.redirect.parameters[i].value
                            });
                            this.threeDs[
                                response.data.redirect.parameters[i].name
                            ] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch(errors => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.$http
                .post("/account/billing/card", { id: id })
                .then(response => {
                    this.user.cards.push(response.data.card);
                    this.forms.eventSignup.card = response.data.card.id;
                    swal.close();
                })
                .catch(errors => {
                    if (errors.number) {
                        swal({
                            type: "error",
                            title: "Whoops",
                            text: errors.number
                        });
                    }
                });
        },

        dateChanged: function() {
            var vm = this;
            var numberOfDates = vm.forms.eventSignup.dates.length;
            var pricingDayCount = vm.forms.eventSignup.pricingOption.day_count;
            if (numberOfDates > pricingDayCount) {
                vm.forms.eventSignup.dates = _.slice(
                    vm.forms.eventSignup.dates,
                    1
                );
            }
        },

        register: function() {
            this.forms.eventSignup.errors.forget();
            this.forms.eventSignup.busy = true;
            // this.process();
            this.sendRegistration();
        },

        sendRegistration: function() {
            
            this.forms.eventSignup.busy = true;
            
            if (!this.validate()) {
                return;
            }

            if (
                this.forms.eventSignup.paymentOption == "eft" &&
                this.instant_eft_success == false
            ) {
                this.forms.eventSignup.busy = true;
                return;
            }

            if (
                this.forms.eventSignup.paymentOption == "cc" &&
                !this.forms.eventSignup.card
            ) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Unable to register without credit card, please select credit card"
                });
                this.forms.eventSignup.busy = false;
                return;
            }

            var payload = {
                dates: this.forms.eventSignup.dates,
                extras: this.forms.eventSignup.extras,
                dietary: this.forms.eventSignup.dietaryRequirement,
                terms: this.forms.eventSignup.terms,
                card: this.forms.eventSignup.card,
                donations: this.getDonations(),
                paymentOption: this.forms.eventSignup.paymentOption,
                staffs: this.forms.eventSignup.staffs,
                isgroupbooking: this.TicketTypeState,
                promo_code_id: this.promo_code_id,
                selectedEventId: this.event.id,
                selectedVenueId: this.forms.eventSignup.venue.id,
                selectedPricingId: this.forms.eventSignup.pricingOption.id,
                type: this.TicketTypeState == "true" ? 1 : 0,
                id_number: this.id_number,
                id_type: this.id_type,
                country_of_issue: this.country_of_issue,
                incometax_reference_number: this.incometax_reference_number,
                company_name: this.company_name,
                company_registrations_number: this.company_registrations_number,
                is_new_feature: true,
                date_of_birth: this.date_of_birth,
                post_code: this.post_code,
                postal_address: this.postal_address
            };

            this.processPayment();
            this.beginCheckout();

            this.$http
                .post("/events/" + this.event.slug + "/register", payload)
                .then(response => {
                  
                    this.forms.eventSignup.busy = false;        
                    
               
                    if (response.data.invoice !== undefined) {
                        this.sendTransactions(response.data.invoice);
                    }
                   
                    swal(
                        {
                            type: "success",
                            title: "Payment Successful",
                            text: "Thank you for your payment",
                            showConfirmButton: false,
                        }
                    );

                    setTimeout(() => {
                        window.location =
                            this.forms.eventSignup.paymentOption == "po"
                                ? "/dashboard/invoice_orders"
                                : "/dashboard/invoices";
                    }, 2000);

                })
                .catch(errors => {

                    var status = errors && errors.status;
                    var data   = errors && errors.data;

                    // Already registered — the user has a ticket. Do not allow re-submission;
                    // redirect to their invoices so they can see the booking.
                    var alreadyRegisteredMessage =
                        (data && typeof data.message === 'string' && data.message.toLowerCase().indexOf('already registered') !== -1 && data.message) ||
                        (data && typeof data.errors === 'string' && data.errors.toLowerCase().indexOf('already registered') !== -1 && data.errors);

                    if (alreadyRegisteredMessage) {
                        swal({
                            type: 'info',
                            title: 'Already Registered',
                            text: alreadyRegisteredMessage,
                            showConfirmButton: true
                        });
                        setTimeout(function() {
                            window.location = '/dashboard/invoices';
                        }, 3000);
                        return;
                    }

                    if (status === 429) {
                        swal({
                            type: 'info',
                            title: 'Please Wait',
                            text: 'Your registration is already being processed. Please check your invoices in a moment.',
                            showConfirmButton: true
                        });
                        setTimeout(function() {
                            window.location = '/dashboard/invoices';
                        }, 3000);
                        return;
                    }


                    this.forms.eventSignup.busy = false;
                    this.forms.eventSignup.errors.set(errors);
                    this.address.errors = errors;
                    try {
                        
                        var message = (data && data.message) ||
                                      (data && typeof data.errors === 'string' && data.errors) ||
                                      'There was a problem with your registration. Please try again.';
                        swal({
                            type: "warning",
                            title: "Error",
                            text: message,
                            showConfirmButton: true
                        });
                    } catch (error) {
                        console.log(error);
                    }
                });
        },

        cancelPayment: function() {
            this.forms.eventSignup.busy = false;
        },

        getEftLink: async function() {
            this.processPayment();
            this.showModal = true;
            await this.loadPeachScript();

            let data = {
                donations: this.getDonations(),
                paymentOption: this.forms.eventSignup.paymentOption,
                staffs: this.forms.eventSignup.staffs,
                isgroupbooking: this.TicketTypeState,
                promo_code_id: this.promo_code_id,
                selectedEventId: this.event.id,
                selectedVenueId: this.forms.eventSignup.venue.id,
                selectedPricingId: this.forms.eventSignup.pricingOption.id,
                type: this.TicketTypeState == "true" ? 1 : 0
            };

            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                    let message = "Unable to process your request!";

                    if (error.status == 422) {
                        message = error.data.message;
                    }

                    swal({
                        type: "warning",
                        title: "Error",
                        text: message,
                        showConfirmButton: true
                    });
                    this.forms.eventSignup.busy = false;
                    return;
                });
        },
        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.closeModal();
                            this.forms.eventSignup.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.eventSignup.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.eventSignup.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },

        startListener: function() {
            var pusher = new Pusher("5e9e56a5a0ebaf5484b0", {
                cluster: "mt1"
            });

            var channel = pusher.subscribe("instantefts");

            channel.bind(
                "App\\Events\\InstantEftNotificationReceived",
                data => {
                    if (this.payment_token == data.payment_key) {
                        if (data.success === true) {
                            this.process();
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            this.cancelPayment();
                            swal({
                                type: "error",
                                title: "Error",
                                text:
                                    "Your Payment has failed, please try again"
                            });
                        }
                    }
                }
            );
        },

        setVenues: function() {
            for (var i = this.event.venues.length - 1; i >= 0; i--) {
                if (this.event.venues[i].city) {
                    this.venues.push(this.event.venues[i]);
                } else {
                    this.online_venues.push(this.event.venues[i]);
                }
            }

            this.venues = _.sortBy(this.venues, function(o) {
                return o.dates[0].date;
            });

            if (this.venues.length == 0 && this.online_venues.length == 1)
                this.selectVenue(this.online_venues[0]);
        },

        setDietary: function setDietary() {
            this.forms.eventSignup.dietaryRequirement = this.dietary[0];
        },

        setMembers: function setMembers() {
            this.members = this.staff;
        },

        setExtras: function() {
            for (var i = this.event.extras.length - 1; i >= 0; i--) {
                this.extras.push(this.event.extras[i]);
            }
        },

        setSelectedStaff: function(id) {
            if (id.target.checked) {
                this.selectedStaff.push(id.target.value);
            } else {
                this.selectedStaff.splice(
                    $.inArray(id.target.value, this.selectedStaff),
                    1
                );
            }
            this.forms.eventSignup.staffs = this.selectedStaff;
        },

        toggleStaff() {
            if (this.inviteStaff) {
                this.inviteStaff = false;
            } else {
                this.inviteStaff = true;
            }
        },
        cancelInvite() {
            this.company.invite.first_name = "";
            this.company.invite.last_name = "";
            this.company.invite.email = "";
            this.company.invite.id_number = "";
            this.company.invite.alternative_cell = "";
            this.company.invite.cell = "";
            this.addingMemberDetails = false;
            this.inviteStaff = false;
        },
        checkInviteMember() {
            if (this.company.invite.first_name == "") {
                this.errors.invite.first_name = "First name is required";
            }
            if (this.company.invite.last_name == "") {
                this.errors.invite.last_name = "Last name is required";
            }
            if (this.company.invite.email == "") {
                this.errors.invite.email = "Email is required";
            }

            if (this.company.invite.cell == "") {
                this.errors.invite.cell = "Cell is required";
            }
            if (
                this.errors.invite.cell ||
                this.errors.invite.first_name ||
                this.errors.invite.last_name ||
                this.errors.invite.email
            ) {
                swal({
                    type: "warning",
                    title: "Fill all the fields"
                });
                this.errors.invite.cell = "";
                this.errors.invite.first_name = "";
                this.errors.invite.last_name = "";
                this.errors.invite.email = "";
                return false;
            }
            return true;
        },
        sendInvitation() {
            if (this.checkInviteMember()) {
                if (
                    !this.pendingMembersEmails.includes(
                        this.company.invite.email
                    )
                ) {
                    this.pendingMembersEmails.push(this.company.invite.email);
                    var input_cell = document.querySelector(
                        "#full_number_invite_cell"
                    );
                    var iti_cell = window.intlTelInputGlobals.getInstance(
                        input_cell
                    );
                    var input_alternative_cell = document.querySelector(
                        "#full_number_invite_alternative_cell"
                    );
                    var iti_alternative_cell = window.intlTelInputGlobals.getInstance(
                        input_alternative_cell
                    );
                    this.pendingMembers.push({
                        first_name: this.company.invite.first_name,
                        last_name: this.company.invite.last_name,
                        email: this.company.invite.email,
                        id_number: this.company.invite.id_number,
                        alternative_cell: iti_alternative_cell.getNumber(),
                        cell: iti_cell.getNumber()
                    });
                    this.members.push({
                        first_name: this.company.invite.first_name,
                        last_name: this.company.invite.last_name,
                        email: this.company.invite.email,
                        id_number: this.company.invite.id_number,
                        alternative_cell: iti_alternative_cell.getNumber(),
                        cell: iti_cell.getNumber()
                    });
                    this.forms.eventSignup.staffs.push({
                        first_name: this.company.invite.first_name,
                        last_name: this.company.invite.last_name,
                        email: this.company.invite.email,
                        id_number: this.company.invite.id_number,
                        alternative_cell: iti_alternative_cell.getNumber(),
                        cell: iti_cell.getNumber()
                    });
                    this.company.invite.first_name = "";
                    this.company.invite.last_name = "";
                    this.company.invite.email = "";
                    this.company.invite.id_number = "";
                    this.company.invite.alternative_cell = "";
                    this.company.invite.cell = "";
                    this.addingMemberDetails = false;
                    this.prices.push(
                        this.getPriceAfterApplyCoupon(
                            this.forms.eventSignup.pricingOption.price
                        )
                    );
                    this.totalGroupBookingUser += 1;
                } else {
                    swal({
                        type: "warning",
                        title: "This member is already added"
                    });
                }
            }
        },
        checkAndFillMember() {
            if (
                this.invite_email == "" ||
                !this.isValidEmail(this.invite_email)
            ) {
                swal({
                    type: "warning",
                    title: "Please enter valid email"
                });
                this.invite_email = "";
                return false;
            }

            var current_email = this.invite_email;

            var exist = false;
            this.members.forEach(function callback(memberDetail, index) {
                if (memberDetail.email == current_email) {
                    exist = true;
                }
            });

            if (exist) {
                swal({
                    type: "warning",
                    title: "Given Email Is Already Added",
                    text: "Try To Add Other Email"
                });
                this.inviteStaff = false;
                this.invite_email = "";
                return false;
            }

            this.$http
                .post("/checkuser", {
                    email: this.invite_email,
                    event_id: this.event.id,
                    price_id: this.forms.eventSignup.pricingOption.id
                })
                .success(response => {
                    if (response.status == "success") {
                        if (response.hasTicket) {
                            swal({
                                type: "warning",
                                title: "User already registered for this event",
                                text: "Try To Add Other Email"
                            });
                        } else {
                            this.members.push(response.member);
                            this.forms.eventSignup.staffs.push(
                                response.member.id
                            );
                            this.prices.push(response.member.price);
                            if (
                                this.getPriceAfterApplyCoupon(
                                    this.forms.eventSignup.pricingOption.price
                                ) == response.member.price
                            ) {
                                this.totalGroupBookingUser += 1;
                            }
                        }
                    } else {
                        this.company.invite.email = this.invite_email;
                        this.addingMemberDetails = true;
                    }

                    this.inviteStaff = false;
                    this.invite_email = "";
                })
                .catch(errors => {
                    // this.errors.invite=errors.data;
                });
        },
        isValidEmail: function(email) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                return true;
            } else {
                return false;
            }
        },

        removeMember: function(member) {
            var deleteIndex;

            this.members.forEach(function callback(memberDetail, index) {
                if (memberDetail.email == member.email) {
                    deleteIndex = index;
                }
            });

            if (
                this.prices[deleteIndex] ==
                this.getPriceAfterApplyCoupon(
                    this.forms.eventSignup.pricingOption.price
                )
            ) {
                this.totalGroupBookingUser -= 1;
            }
            this.members.splice(deleteIndex, 1);
            this.prices.splice(deleteIndex, 1);
            this.forms.eventSignup.staffs.splice(deleteIndex, 1);
            this.pendingMembers.splice(deleteIndex, 1);
            this.pendingMembersEmails.splice(
                $.inArray(member.email, this.pendingMembersEmails),
                1
            );
        },

        selectVenue: function(venue) {
            var vm = this;
            vm.forms.eventSignup.venue = venue;
            vm.pricingOptions = venue.pricings;

            if (venue.pricings.length <= 1) this.autoSelectPricing(venue);
        },

        selectAnotherVenue: function() {
            this.forms.eventSignup.venue = null;
            this.forms.eventSignup.pricingOption = null;
            this.forms.eventSignup.dates = [];
            this.forms.eventSignup.paymentOption = null;
        },

        autoSelectPricing: function(venue) {
            this.forms.eventSignup.pricingOption = venue.pricings[0];
        },

        autoSelectAllDates: function() {
            var vm = this;
            _.forEach(vm.forms.eventSignup.venue.dates, function(
                date,
                dateKey
            ) {
                vm.forms.eventSignup.dates.push(date);
                }
            );
        },

        /*
         * Calculate the total Pricings
         */
        getTotalPricing: function () {
            if (!this.forms.eventSignup.pricingOption) return 0;

            var price = this.forms.eventSignup.pricingOption.price;

            if (this.forms.eventSignup.pricingOption.discount > 0)
                price = this.forms.eventSignup.pricingOption.discounted_price;

            if (
                this.forms.eventSignup.staffs.length > 0 &&
                this.TicketTypeState
            ) {
                if (
                    this.pricegroup.length > 0 &&
                    this.forms.eventSignup.staffs.length > 1
                ) {
                    var lastPrice = price;
                    var discount = 0;
                    var len = this.forms.eventSignup.staffs.length;
                    for (var i = 2; i <= len; i++) {
                        for (var j = 0; j < this.pricegroup.length; j++) {
                            if (
                                i >= this.pricegroup[j].min_user &&
                                i <= this.pricegroup[j].max_user
                            ) {
                                discount = this.pricegroup[j].discount;
                                var discountPrice = Math.round(
                                    (lastPrice * discount) / 100
                                );
                                lastPrice = lastPrice - discountPrice;
                            }
                        }
                    }
                    price = lastPrice;
                }
                price = price * this.forms.eventSignup.staffs.length;
            }

            if (
                this.TicketTypeState &&
                this.forms.eventSignup.staffs.length == 0
            ) {
                price = 0;
            }
            return price;
        },

        /*
         * Calculate the total Diatry Requirements
         */
        getTotalDiatry: function() {
            if (this.forms.eventSignup.dietaryRequirement != null) {
                if (this.forms.eventSignup.dietaryRequirement.price > 0) {
                    totalDiatry = this.forms.eventSignup.dietaryRequirement
                        .price;

                    if (this.forms.eventSignup.dates.length > 1) {
                        totalDiatry =
                            totalDiatry * this.forms.eventSignup.dates.length;
                    }

                    if (this.forms.eventSignup.staffs.length > 0) {
                        totalDiatry =
                            totalDiatry * this.forms.eventSignup.staffs.length;
                    }

                    if (
                        this.TicketTypeState &&
                        this.forms.eventSignup.staffs.length == 0
                    ) {
                        totalDiatry = 0;
                    }

                    return totalDiatry;
                } else {
                    return 0;
                }
            }

            return 0;
        },

        /*
         * Calculate the total Extras
         */
        getTotalExtras: function() {
            var total = 0;

            this.forms.eventSignup.extras.forEach(extra => {
                total = parseInt(total) + parseInt(extra.price);
            });

            if (this.forms.eventSignup.staffs.length > 0) {
                total = total * this.forms.eventSignup.staffs.length;
            }

            if (
                this.TicketTypeState &&
                this.forms.eventSignup.staffs.length == 0
            ) {
                total = 0;
            }

            return total;
        },

        /*
         * Calculate the donation
         */
        getDonations: function() {
            var total = 0;
            if (this.forms.eventSignup.donations) {
                total = this.donations;
            }
            return total;
        },

        getPriceCalculartion(min, max, title) {
            var price = 0;
            if (this.forms.eventSignup.pricingOption != null) {
                price = this.getPriceAfterApplyCoupon(
                    this.forms.eventSignup.pricingOption.price
                );
            } else {
                price = this.getPriceAfterApplyCoupon(
                    this.pricingOptions[0].price
                );
            }
            var discount = 0;
            var discountPrice = 0;
            var lowerprice = price;
            var i, j;
            if (max == 0) {
                max = min;
            }

            if (title == "medium-size") {
                min = min - 1;
            }

            for (i = 2; i <= min; i++) {
                for (j = 0; j < this.pricegroup.length; j++) {
                    if (
                        i >= this.pricegroup[j].min_user &&
                        i <= this.pricegroup[j].max_user
                    ) {
                        discount = this.pricegroup[j].discount;
                        discountPrice = Math.round(
                            (lowerprice * discount) / 100
                        );
                        lowerprice = lowerprice - discountPrice;
                    }
                }
            }

            for (i = 2; i <= max; i++) {
                for (j = 0; j < this.pricegroup.length; j++) {
                    if (
                        i >= this.pricegroup[j].min_user &&
                        i <= this.pricegroup[j].max_user
                    ) {
                        discount = this.pricegroup[j].discount;
                        discountPrice = Math.round((price * discount) / 100);
                        price = price - discountPrice;
                    }
                }
            }

            if (max == min) {
                return "From " + price + " per person";
            }
            return "From " + lowerprice + " - " + price + " per person";
        },

        getTotalGroupBookingDiscount() {
            var totalDiscount = 0;
            if (!this.forms.eventSignup.pricingOption) return 0;

            var price = this.getPriceAfterApplyCoupon(
                this.forms.eventSignup.pricingOption.price
            );

            var lastPrice = price;

            if (this.totalGroupBookingUser > 0 && this.TicketTypeState) {
                if (
                    this.pricegroup.length > 0 &&
                    this.totalGroupBookingUser > 1
                ) {
                    var discount = 0;
                    var len = this.totalGroupBookingUser;
                    for (var i = 2; i <= len; i++) {
                        for (var j = 0; j < this.pricegroup.length; j++) {
                            if (
                                i >= this.pricegroup[j].min_user &&
                                i <= this.pricegroup[j].max_user
                            ) {
                                discount = this.pricegroup[j].discount;
                                var discountPrice =
                                    (lastPrice * discount) / 100;
                                lastPrice = lastPrice - discountPrice;
                            }
                        }
                    }
                }
            }

            totalDiscount =
                parseFloat(price - lastPrice) * this.totalGroupBookingUser;
            if (
                this.TicketTypeState &&
                this.forms.eventSignup.staffs.length == 0
            ) {
                totalDiscount = 0;
            }

            return totalDiscount.toFixed(2);
        },

        process: function() {
            swal({
                title: "",
                text:
                    '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: "no-bg"
            });
        },

        processPayment: function() {
            swal({
                type: "warning",
                title: "Payment Processing",
                text: "Please wait while we are processing your payment.Do not Refresh page or close browser"
            });
        },


        beginCheckout: function () {

            window.dataLayer = window.dataLayer || [];

            var items = [];

            items.push({
                item_id: String(this.event.id),
                item_name: this.event.name,
                item_category: "Event",
                price: parseFloat(parseFloat(this.total).toFixed(2)),
                quantity:  this.forms.eventSignup.staffs.length > 0 ?  this.forms.eventSignup.staffs.length : 1
            });

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    value: parseFloat(parseFloat(this.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,

            });
        },

        sendTransactions: function (invoice) {
            
            window.dataLayer = window.dataLayer || [];

            var items = [];

            if (invoice.items && invoice.items.length > 0) {
                invoice.items.forEach(function (item) {
                    items.push({
                        item_id: String(item.item_id),
                        item_name: item.name,
                        item_category: "Event",
                        price: parseFloat(parseFloat(item.price).toFixed(2)),
                        quantity: item.quantity
                    });
                });
            }

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: invoice.reference,
                    value: parseFloat(parseFloat(invoice.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                payment_method: this.getPaymentMethod() || undefined,
                payment_status: invoice.paid == 1 ?  "successful" : "failed",
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        getPaymentMethod:function(){
          
            if(this.forms.eventSignup.paymentOption == 'cc'){
              return  'Credit Card';
            }  
            
            if(this.forms.eventSignup.paymentOption == 'eft'){
              return  'Instant EFT';
            }  

            return "Purchase Order";
        },



        /*
         * Get the proper column width based on the number of venues.
         */
        getVenueColumnWidth: function(count) {
            switch (count) {
                case 1:
                    return "col-md-4 col-md-offset-4";
                case 2:
                    return "col-md-6";
                case 3:
                    return "col-md-4";
                case 4:
                    return "col-md-3";
                default:
                    return "col-md-2";
            }
        },

        getPriceAfterApplyCoupon: function(price) {
            if (
                this.usedcoupon != null &&
                this.usedcoupon != "" &&
                this.usedcoupon != undefined
            ) {
                if (this.usedcoupon.discount_type == "percentage") {
                    var disounted =
                        (price * this.usedcoupon.discount_amount) / 100;
                    return parseFloat(price) - parseFloat(disounted);
                } else {
                    return (
                        parseFloat(price) -
                        parseFloat(this.usedcoupon.discount_amount)
                    );
                }
            }
            return parseFloat(price);
        },

        updatedPrices: function() {
            this.prices = [];
            this.totalGroupBookingUser = 0;
            this.$http
                .post("/get_price_details", {
                    staffs: this.forms.eventSignup.staffs,
                    price_id: this.forms.eventSignup.pricingOption.id
                })
                .success(response => {
                    for (var i = 0; i < response.length; i++) {
                        this.prices.push(response[i]);
                        if (
                            this.getPriceAfterApplyCoupon(
                                this.forms.eventSignup.pricingOption.price
                            ) == response[i]
                        ) {
                            this.totalGroupBookingUser += 1;
                        }
                    }
                })
                .catch(errors => {
                    // this.errors.invite=errors.data;
                });
        },

        validate: function() {
            if (!this.forms.eventSignup.terms) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Please accept term's and condition to process booking!"
                });
                this.forms.eventSignup.busy = false;
                return false;
            }

            if (this.forms.eventSignup.donations) {
                if (this.id_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter id number"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.id_type == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid id type"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.country_of_issue == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select valid country"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.incometax_reference_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select valid income tax reference number!"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.company_name == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid company name!"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.company_registrations_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter company registration number"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.date_of_birth == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select date of birth"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }

                if (this.postal_address == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid postal address"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }
                if (this.post_code == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid postal code"
                    });
                    this.forms.eventSignup.busy = false;
                    return false;
                }
            }

            return true;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/events/single/single.js